import * as Styled from './Card.styles';
import PropTypes from 'prop-types';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import verifyArray from '../../utils/verifyArray';
import { theme } from '../../styles/theme';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import DateInput from '../DateInput/DateInput';
import Button from '../Button/Button';
import { getDataSaldoGeralFetchAction } from '../../store/fetchActions/getSaldoGeral';
export default function Card(props) {
  const {
    isExpanded,
    setIsExpanded,
    expandedHeight,
    height,
    width,
    color,
    iconColor,
    backgroundColorContainer,
    icon,
    text,
    value,
    name,
    data,
  } = props;

  const dispatch = useDispatch();
  const { handleSubmit, control } = useForm({});
  const { rbmWhite, secondaryColor, mainColorButtonHover } = theme.colors;

  const getSaldo = (data) => {
    dispatch(getDataSaldoGeralFetchAction(data.DATA));
  };

  return (
    <Styled.CardComponent
      width={width}
      height={isExpanded ? expandedHeight : height}
    >
      <Styled.Rectangle color={color} />
      <Styled.Container>
        <Styled.Line>
          <Styled.CardHeaderContainer>
            <Styled.IconContainer
              iconColor={iconColor}
              backgroundColor={backgroundColorContainer}
            >
              {icon}
            </Styled.IconContainer>
            <Styled.Name>{name}</Styled.Name>
          </Styled.CardHeaderContainer>
          <Styled.CardHeaderContainer>
            <Styled.Button
              size="small"
              onClick={() => setIsExpanded(!isExpanded)}
              data-cy="btn-isExpanded-cards"
            >
              {isExpanded ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </Styled.Button>
          </Styled.CardHeaderContainer>
        </Styled.Line>
        <Styled.LineValue>
          <Styled.NameTotal>{text}</Styled.NameTotal>
          <Styled.Value>R$ {formatMoney(value)}</Styled.Value>
        </Styled.LineValue>

        {verifyArray(data) &&
          data.map((card, index) => {
            return (
              <>
                <Styled.LineInCard
                  key={index}
                  display={isExpanded ? 'flex' : 'none'}
                >
                  <Styled.TextInCard>{card.name}</Styled.TextInCard>
                  <Styled.ValueInCard>
                    {card.name === 'Data' || card.name === 'Hora'
                      ? card.value
                      : 'R$ ' + formatMoney(card.value)}
                  </Styled.ValueInCard>
                </Styled.LineInCard>
                {isExpanded && index !== data?.length - 1 && (
                  <Styled.LineSeparator />
                )}
              </>
            );
          })}

        {name === 'Saldo Conta Digital' ? (
          <form onSubmit={handleSubmit(getSaldo)}>
            <Styled.Line>
              <DateInput
                label="Data"
                name={'DATA'}
                variant="standard"
                control={control}
                width={'12vw'}
              />
              <Button
                backgroundColor={mainColorButtonHover}
                width={'6vw'}
                hoverBGColor={secondaryColor}
                hoverColor={rbmWhite}
                color={rbmWhite}
                type="submit"
              >
                Checar
              </Button>
            </Styled.Line>
          </form>
        ) : null}
      </Styled.Container>
    </Styled.CardComponent>
  );
}

Card.propTypes = {
  icon: PropTypes.string,
  width: PropTypes.string,
  expandedHeight: PropTypes.string,
  height: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
  value: PropTypes.number,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  data: PropTypes.array,
  color: PropTypes.string,
  backgroundColorContainer: PropTypes.string,
  iconColor: PropTypes.string,
};
